{
  "pt": {
    "validation": {
      "emailAddressDemo": "O endereço de email de um contacto neste cliente demo deve terminar com '{email_address_suffix}' ou '@ziggu.io'",
      "emailTaken": "O endereço de correio eletrónico já está ocupado",
      "errorsInLanguages": "Algumas traduções contêm erros, verifique: {languages}",
      "fix_errors": "Falha ao guardar, corrija os erros",
      "import": {
        "inclusion": "Erro na linha {rowNumber} coluna {columnNumber}: {headerName} não está incluído na lista",
        "inclusion_values": "com valores permitidos: {values}",
        "invalid": "Erro na linha {rowNumber} coluna {columnNumber}: {headerName} não é válido",
        "required": "Erro na linha {rowNumber} coluna {columnNumber}: é necessário um valor para {headerName} ",
        "unique": "Erro na linha {rowNumber}: {headerName} não é único, existe outra linha com este valor"
      },
      "nameAlreadyTaken": "O nome já está ocupado",
      "needCompany": "A empresa é obrigada",
      "needName": "O nome é obrigatório"
    }
  }
}
